





























import { Vue, Component, Ref, Prop, Watch } from 'vue-property-decorator'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import {  obrigatorio } from '@/shareds/regras-de-form'
import type { FamiliaDoProduto } from '@/models'
import { SaveFamiliaDoProdutoUseCase } from '@/usecases/produto/tipoProduto'

@Component({
	components: {
	},
})

export default class DialogoDeEdicaoDeFamiliaDoProduto extends Vue {
	@Ref() form!: HTMLFormElement
	@Prop({type: Object}) familia?: FamiliaDoProduto
	familiaEmEdicao: FamiliaDoProduto = { id: '', nome: '' } 
	mostra = false
	salvando = false

	saveFamiliaDoProdutoUseCase = new SaveFamiliaDoProdutoUseCase()

	obrigatorio = obrigatorio

	mostrar() {		
		this.onChangeFamilia()
		this.mostra = true
	}

	esconder() {
		this.familiaEmEdicao = { id: '', nome: '' }
		this.mostra = false
	}

	async salvar() {
		if (!this.familia) return
		if (!this.familiaEmEdicao) return
		if (!this.form.validate()) return

		try {
			this.salvando = true 
			
			this.editarFamilia()
			
			const familiaSalva = !this.familia.id
				? await this.saveFamiliaDoProdutoUseCase.criarFamiliaDoProduto(this.familia)
				: await this.saveFamiliaDoProdutoUseCase.editarFamiliaDoProduto(this.familia)

			this.$emit('confirmado', familiaSalva)
			AlertModule.setSuccess('Familia salva com sucesso')
		} catch(error: any) {
			AlertModule.setError(error.response.data[0])
		} finally {
			this.salvando = false
			this.mostra = false
		}
	}

	editarFamilia() {
		if(this.familia && this.familiaEmEdicao) {
			this.familia.nome = this.familiaEmEdicao.nome
		}
	}

	@Watch('familia')
	onChangeFamilia() {			
		this.familiaEmEdicao.nome = this.familia ? this.familia.nome : ''
	}
}
